__webpack_require__.p = "/fifa-score/";